import './wp-hd-order.scss';

import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import WpBaseComponent from './../wp-base-component';
import GlobalService, { IHelpDeskService, HelpDeskSymbols, INotificationService, NotificationSymbols, ActionResult, AppSettings } from 'web-platform-help-desk-core-frontend-ui';
import { Prop } from 'vue/types/options';
import { Watch } from 'vue-property-decorator';

export const wpHdOrderProps = Vue.extend({
    props: {
        data: {
            type: Object as Prop<any>,
            required: true
        },
        refundMode: {
            type: Boolean,
            required: false
        }
    }
});

@Component({
    template: require("./wp-hd-order.html")
})
export default class WpHdOrder extends mixins(WpBaseComponent, wpHdOrderProps, Vue) {
    protected _service!: IHelpDeskService;
    protected _notificationService!: INotificationService;
    protected _appSetting!: AppSettings;

    ShowTicketBarcodes: boolean = false;
    DisabledUI: boolean = false;

    applicationIsRequired: boolean = false;

    SelectedTickets: Array<any> = [];
    ExampleApplication: string = require("@/assets/ExampleApplication.png");

    // Нужно для возврата
    FileRefundRequest: File | null = null;
    Comment: string = "";

    get IsAllowedShowBarcodes(): boolean {
        let items = new Array<any>();

        for (let item of this.data.items)
            if (item.status != 1 && item.status != 2 && item.haveTicket && !item.hdRefundProcess)
                items.push(item);

        return items.length > 0;
    }
    get IsFullScreenBarcodeDialog(): boolean {
        return !this.$vuetify.breakpoint.smAndUp;
    }
    get IsEqualZeroSum() {
        if (this.data == null)
            return false;

        let isEqual = false;

        this.data.items!.forEach((x : any) => {
            if (x.totalSum == 0)
                isEqual = true;
        });

        return isEqual;
    }

    async FileToB64(file: File): Promise<string | void> {
        if (!file) return console.error("File not specified");
        let promise = new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result!.toString());
            reader.onerror = error => reject(error);
        });
        return promise;
    };

    created(): void {
        this._service = this.GlobalService.Get<IHelpDeskService>(HelpDeskSymbols.HelpDeskService);
        this._notificationService = this.GlobalService.Get<INotificationService>(NotificationSymbols.NotificationService);
        this._appSetting = GlobalService.GetSettings();

        fetch(this._appSetting.HelpAddress + `/api/order/refundMode`).then((result) => {
            if (result.ok) {
                result.json().then((data) => {
                    if (data.result == 0)
                        this.applicationIsRequired = data.data;
                    else
                        this._notificationService.Error("Ошибка", data.message ?? "Повторите запрос позднее");
                });
            } else {
                this._notificationService.Error("Ошибка", "Повторите запрос позднее");
            };
        });

        console.log(this.data.items);
    };

    CloseDialog(): void {
        this.$emit("CloseDialog");
    };

    async DownloadTicket(orderItemId: number, status: number): Promise<ActionResult> {
        this.DisabledUI = true;
        if (status == 0) {

            let a = document.createElement('a');
            document.body.appendChild(a);

            a.href = this._appSetting.HelpAddress + `/api/order/ticket/download?id=${orderItemId}&token=${this.data.access_token}`;
            a.click();
            document.body.removeChild(a);
        } else {
            this._notificationService.Error("Ошибка", "Билет возвращён");
        };
        this.DisabledUI = false;
        return ActionResult.Success();
    };

    async RequestRefund(): Promise<void> {
        this.DisabledUI = true;

        let file: string | void = "";
        if (this.FileRefundRequest) file = await this.FileToB64(this.FileRefundRequest);

        let itemsToRefund: Array<RefundRecordItem> = [];
        this.SelectedTickets.forEach((t: any) => {
            let itr = new RefundRecordItem();
            itr.Id = t.id;
            itr.Sum = t.totalSum;
            itemsToRefund.push(itr);
        });

        let refund = {
            userName: this.data.userName,
            userPhone: this.data.userPhone,
            orderCode: this.data.code,
            orderId: this.data.id,
            itemIds: itemsToRefund,
            comment: this.Comment,
            file: file
        };
        let q = await this._service.RequestRefundAsync(refund);
        if (q.Success) {
            this._notificationService.Success("Возврат", "Заявка на возврат успешно зарегистрирована");
            this.CloseDialog();
        } else {
            this._notificationService.Error("Возврат", q.ErrorMessage || "Не удалось зарегистрировать заявку");
        }

        this.DisabledUI = false;
    };
};

class RefundRecordItem {
    Id!: number;
    Sum!: number;
};